import './WhoWeAre.css'

const WhoWeAre = () => {
    return (
        <div className='about_box'>
            <div className='about_us_wwa_title'>Who We Are</div>
            <hr/>
            <div className="about_us_wwa_content">                
                <img className="about_us_wwa_pic_3" alt="pic" />
                <div className='about_us_wwa_text'>
                    <p>SVLC, founded in 2019, is one of the world's largest Leadership Communities with hundreds of Executives and Leaders, including distinguished executives, managers from world-class companies, top university professors, venture capitalists, professionals holding MBAs from top business schools, and Entrepreneurs in Silicon Valley. </p>
                </div>
            </div>
        </div>
    )
}

export default WhoWeAre;
